function CalculateLineTotal(qty, unit, discount) {
  let q = parseInt(qty);
  let u = parseFloat(unit);
  let d = parseFloat(discount);

  return q * u - d;
}

export { CalculateLineTotal };
